import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { AddOperationsStopComponent } from 'src/app/components/operations/route-summary/route-details/add-operations-stop/add-operations-stop.component';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { STOP_TYPE } from 'src/app/core/enums/operations.enum';
import {
  CreateDeliveryRequest,
  CreateDeliveryResponse,
} from 'src/app/core/models/operations/operations-delivery.model';
import {
  CreatePickupRequest,
  CreatePickupResponse,
} from 'src/app/core/models/operations/operations-pickup-stop.model';
import { DataService } from 'src/app/core/services/data/data.service';
import { DeliveryService } from 'src/app/core/services/operations/delivery/delivery.service';
import { PickupService } from 'src/app/core/services/operations/pickup/pickup.service';
import { currentLocale } from 'src/app/locale.config';
import { ROUTE_DETAILS_CONSTANTS } from './route-details.constants';

@Component({
  selector: 'app-route-details',
  templateUrl: './route-details.component.html',
  styleUrls: ['./route-details.component.scss'],
  standalone: false,
})
export class RouteDetailsComponent {
  readonly CONSTANTS = ROUTE_DETAILS_CONSTANTS;
  readonly SRC = IMAGE_SRC;

  constructor(
    private readonly route: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly dialog: MatDialog,
    private readonly deliveryService: DeliveryService,
    private readonly pickupService: PickupService,
    private readonly dataService: DataService,
  ) {}

  /** Navigates back to route summary page, preserving query params */
  goBack() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.route.navigate(['/', currentLocale(), 'operations', 'route-summary'], {
      queryParams: queryParams,
    });
  }

  openAddStopPopup(args: {
    route: string;
    planDate: Date;
    stopType: STOP_TYPE;
    locationCode: string;
  }) {
    const { route, planDate, stopType, locationCode } = args;

    const dialogRef = this.dialog.open(AddOperationsStopComponent, {
      width: '1000px',
      disableClose: true,
      data: {
        route,
        planDate,
        type: stopType,
        trackingNumData: null,
        form: null,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (!result || result.back) return;

        const request = result.request as
          | CreateDeliveryRequest
          | CreatePickupRequest;
        const isDelivery = request?.stop?.stopType === STOP_TYPE.DELIVERY;

        const api$ = isDelivery
          ? this.deliveryService.createDelivery(
              request as CreateDeliveryRequest,
            )
          : this.pickupService.createPickup(
              request as CreatePickupRequest,
              locationCode,
              route,
            );

        api$.pipe(take(1)).subscribe((apiResponse) => {
          const stopId =
            (apiResponse as CreateDeliveryResponse)?.response?.stopId ??
            (apiResponse as CreatePickupResponse)?.response?.stopId ??
            null;

          const infoNotice =
            (request as CreateDeliveryRequest)?.deliveryDetail?.infoNotice ??
            (request as CreatePickupRequest)?.pickupDetail?.infoNotice ??
            '';

          if (stopId != null) {
            this.dataService.setInfoNotice(stopId, infoNotice ?? '');
          }
        });
      });
  }
}
